/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".is-invalid[_ngcontent-%COMP%]{box-shadow:0 0 0 .2rem rgba(255,0,34,.25)}"];
export { styles as styles };
